const decoupeLaser = [];  // No products have images in the catalog

export default decoupeLaser;
